require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./biuro-rachunkowe.json") })
        }
      }, "path---biuro-rachunkowe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---biuro-rachunkowe!./.cache/json/biuro-rachunkowe.json
// module id = 511
// module chunks = 231608221292675